<template>
  <div>
    <div class="container" id="main">
      <h3 class="mainHeader"><img src="../assets/images/myCSUB-primary.png" alt="myCSUB" /></h3>
      <div class="row">
        <div class="col-sm-5 col-sm-offset-1 form-box">
          <h3 class="ftu" @click="dispFTU()">First-time user? Click Here</h3>

          <maint />

        </div>
        <div class="col-sm-5 form-box" id="info">
          <h3><em class="fa fa-bullhorn"></em> Announcements</h3>
          <ul class="icon">
            <div v-for="(item, idx) in announcements" :key="idx">
              <li v-if="idx < 2" v-html="item.entry"></li>
            </div>
            <li><a class="pastAnnounce" title="View Past Announcements" @click="dispPastAnnounce = !dispPastAnnounce">View Past Announcements</a></li>
          </ul>
        </div>
      </div>
    </div>

    <past-announce :announcements="announcements" :dispPastAnnounce="dispPastAnnounce" />
  </div>
</template>

<script>
import $ from 'jquery'
import axios from 'axios'

import maint from '@/components/maintMsg'
import pastAnnounce from '@/components/announcements'

export default {
  name: 'Home',
  components: {
    maint,
    pastAnnounce
  },

  data () {
    return {
      buttonLoc: 'https://cmsweb.cms.csub.edu/psp/CBAKPRD/?cmd=login',
      announcements: [],
      dispPastAnnounce: false
    }
  },

  async created () {
    const { data: announcementData } = await axios.get('https://www.csub.edu/mycsub/static/data/announcements.json?nocache' + (new Date()).getTime())
    this.announcements = announcementData
  },

  methods: {
    dispFTU: function () {
      $('#firstTimeUserPopUp').fadeIn(600)
      $('#main').fadeOut(800)
      $('#pastInfo').fadeOut(800)
    }
  }
}
</script>

<style scoped>
  .btn {
    width: 100%;
    margin: 10px 0;
  }

  .btn-secondary {
    border: 1px solid;
    background: #ccc;
    color: #000;
  }

  h3.mainHeader img {
    width: 250px;
  }

  #main h3 {
    font-family: 'Oswald', sans-serif;
    /* font-weight: bold; */
    color: #003595;
    margin: 15px 0px 0px 30px;
  }
</style>
